import React from 'react';
import styled from '@emotion/styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faVolumeUp, faVolumeMute } from '@fortawesome/free-solid-svg-icons';

const MiniSpeakerButtonIcon = styled(FontAwesomeIcon)({
    fontSize: '20px',
    userSelect: 'none',
    ':hover': {
        color: '#23527c',
    },
});

export type MiniSpeakerButtonProps = {
    mute: boolean;
    onClick: () => void;
}

export const MiniSpeakerButton = (props: MiniSpeakerButtonProps) => {
    return (
        <span onClick={props.onClick}>
            <MiniSpeakerButtonIcon icon={props.mute ? faVolumeMute : faVolumeUp} />
        </span>
    );
};
